import { useT } from "@/i18n/I18nContext";
import { Award, Medal, Crown, Gem } from "lucide-react";

const CONFIG = {
  bronze: { Icon: Medal, cls: "bg-amber-100 text-amber-800" },
  silver: { Icon: Award, cls: "bg-slate-200 text-slate-700" },
  gold: { Icon: Crown, cls: "bg-yellow-100 text-yellow-800" },
};

export const SellerBadge = ({ badge = "none", premium = false, size = "sm" }) => {
  const { t } = useT();
  const pad = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs";
  const iconSize = size === "sm" ? 12 : 14;

  if (!premium && (!badge || badge === "none")) return null;

  return (
    <span className="inline-flex items-center gap-1" data-testid="seller-badge">
      {premium && (
        <span className={`inline-flex items-center gap-1 rounded-full font-semibold bg-gradient-to-r from-primary to-accent text-white ${pad}`} data-testid="badge-premium">
          <Gem style={{ width: iconSize, height: iconSize }} /> {t("badge.premium")}
        </span>
      )}
      {badge && badge !== "none" && CONFIG[badge] && (
        <span className={`inline-flex items-center gap-1 rounded-full font-semibold ${CONFIG[badge].cls} ${pad}`} data-testid={`badge-${badge}`}>
          {(() => { const I = CONFIG[badge].Icon; return <I style={{ width: iconSize, height: iconSize }} />; })()}
          {t(`badge.${badge}`)}
        </span>
      )}
    </span>
  );
};
